import { render, staticRenderFns } from "./login-back.vue?vue&type=template&id=e9c36de8&scoped=true&"
import script from "./login-back.vue?vue&type=script&lang=js&"
export * from "./login-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c36de8",
  null
  
)

export default component.exports